import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["color", "colors", "closable", "deleted", "onClick", "tagClick"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import Tag from './Tag';
import { Warning } from "../../wui-core/src";
var isShouldUpdate = Warning.isShouldUpdate;

var TagWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(TagWrapper, _React$Component);

  var _super = _createSuper(TagWrapper);

  function TagWrapper(props) {
    _classCallCheck(this, TagWrapper);

    return _super.call(this, props);
  }

  _createClass(TagWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          colors = _this$props.colors,
          closable = _this$props.closable,
          deleted = _this$props.deleted,
          onClick = _this$props.onClick,
          tagClick = _this$props.tagClick,
          others = _objectWithoutProperties(_this$props, _excluded);

      isShouldUpdate("Tag", this.props);
      var extral = {
        colors: color ? color : colors,
        deleted: closable ? closable : deleted,
        tagClick: onClick ? onClick : tagClick
      };
      return /*#__PURE__*/React.createElement(Tag, _extends({}, extral, others));
    }
  }]);

  return TagWrapper;
}(React.Component);

export default TagWrapper;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tag/src/index.js